import { render, staticRenderFns } from "./StudentEditTabSecret.vue?vue&type=template&id=708178a2&"
import script from "./StudentEditTabSecret.vue?vue&type=script&lang=js&"
export * from "./StudentEditTabSecret.vue?vue&type=script&lang=js&"
import style0 from "./StudentEditTabSecret.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports